import { render, staticRenderFns } from "./CheckOrMinus.vue?vue&type=template&id=c07a3e66&scoped=true&"
import script from "./CheckOrMinus.vue?vue&type=script&lang=js&"
export * from "./CheckOrMinus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c07a3e66",
  null
  
)

export default component.exports